import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/control-center")({
  component: lazyRouteComponent(() => import("./-pages/admin.control-center")),
});
